import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Global, css } from "@emotion/react";

// Define your CSS variables
const cssVariables = css`
  :root {
    --font-thin: 100;
    --font-extralight: 200;
    --font-light: 300;
    --font-regular: 400;
    --font-medium: 500;
    --font-semibold: 600;
    --font-bold: 700;
    --font-extrabold: 800;
    --font-black: 900;
    --font-size-11: 11px;
    --font-size-12: 12px;
    --font-size-13: 13px;
    --font-size-15: 15px;
    --font-size-16: 16px;
    --font-size-18: 18px;
    --font-size-22: 22px;
    --font-size-100: 100px;
    --primary-color: #000000;
    --secondary-color: #ffffff;
    --placeholder-color: #00000080;
    --inactive-link: #000000b2;
    --whisper-color: #f3f0f8;
    --alabaster-color: #fafafa;
    --wildsand-color: #f5f5f5;
    --silver-color: #c4c4c4;
    --bondiblue-color: #00a2b4;
    --blue: #3b82c4;
    --blue-color: #0019ff;
    --alto-color: #d7d7d7;
    --blackhaze-color: #f3f4f4;
    --iron-color: #d9d9d9;
    --emerald-color: #58cb7f;
    --seagreen-color: #34a058;
    --tumeric-color: #bec145;
    --gold-color: #c5a501;
    --copper-color: #b37329;
    --brown-color: #945000;
    --crimson-color: #da0e1b;
    --red-color: #d32f2f;
    --light-red-color: #ffb09c;
    --gorse-color: #fef445;
    --grey-color: #808080s;
    --disable-color: rgba(0, 0, 0, 0.38);
    --light-darker-gray: #999;
    --lighter-yellow: #fde68a;
    --dark-yellow: #fbbf24;
    --yellow: #ffff00;
    --lighter-blue: #93c5fd;
    --dark-blue: #3b82f6;
    --lighter-green: #d1fae5;
    --dark-green: #10b981;
    --lighter-pink: #fecaca;
    --lighter-reject-gray: #c5b4b4;
    --dark-red: #ef4444;
    --text-dark-yellow: #9b7005;
    --text-dark-blue: #1c53ac;
    --text-dark-green: #0c7954;
    --text-dark-red: #e41a1a;
    --text-reject-light-red: #812929;
    --concrete-color: #f2f2f2;
    --hawkes-color: #ebf2fe;
  }
`;

// Create a custom theme
const theme = createTheme({
  typography: {
    fontFamily: "TT Hoves Pro Trial",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html, body, #root {
          height: 100%;
          margin: 0;
          font-family: "TT Hoves Pro Trial"
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
      `,
    },
  },
});

// ThemeConfig component
const ThemeConfig = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Global styles={cssVariables} />
      {children}
    </ThemeProvider>
  );
};

export default ThemeConfig;
